export default __webpack_public_path__ + "static/media/personality-refresh.7ef58b53.svg";